import React, { useState } from 'react';
import { Mail, Phone, ChevronDown, Menu, X } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="w-full bg-white sticky top-0 z-50 shadow-sm" data-id="element-120">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-[#1e3a4a] to-[#23556e] text-white" data-id="element-121">
        <div className="container mx-auto px-4" data-id="element-122">
          <div className="flex items-center justify-between h-12 text-sm" data-id="element-123">
            <div className="flex items-center gap-6" data-id="element-124">
              <a href="mailto:info@autopoint.si" className="flex items-center gap-2 text-white/90 hover:text-white transition-colors" data-id="element-125">
                <Mail className="w-4 h-4" data-id="element-126" />
                <span className="hidden sm:inline" data-id="element-127">info@autopoint.si</span>
              </a>
              <a href="tel:+38631302033" className="flex items-center gap-2 text-white/90 hover:text-white transition-colors" data-id="element-128">
                <Phone className="w-4 h-4" data-id="element-129" />
                <span data-id="element-130">+386 31 302 033</span>
              </a>
            </div>
            <button className="flex items-center gap-2 bg-white/10 hover:bg-white/15 transition-colors rounded-full px-3 py-1.5" data-id="element-131">
              <span className="text-base leading-none" data-id="element-132">🇸🇮</span>
              <span className="hidden sm:inline" data-id="element-133">Slovensko</span>
              <ChevronDown className="w-3.5 h-3.5" data-id="element-134" />
            </button>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="border-b border-gray-100" data-id="element-135">
        <div className="container mx-auto px-4" data-id="element-136">
          <div className="flex items-center justify-between h-20" data-id="element-137">
            {/* Logo */}
            <a href="#" className="flex items-center" aria-label="Autopoint" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/8W3K6WsSkda3SCEjPHenmx/AP_Logo.9c1472ca.svg" alt="Autopoint" className="h-8 w-auto" data-id="element-139" />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8" data-id="element-140">
              <a href="#" className="text-slate-700 hover:text-slate-900 transition-colors" data-id="element-141">
                Kupi
              </a>
              <a href="#" className="text-[#1EB6E8] font-medium" data-id="element-142">
                Prodaj
              </a>
              <a href="#kako-deluje" className="text-slate-700 hover:text-slate-900 transition-colors" data-id="element-143">
                Kako deluje?
              </a>
              <a href="#faq" className="text-slate-700 hover:text-slate-900 transition-colors" data-id="element-144">
                Pogosta vprašanja
              </a>
              <a href="#" className="text-slate-700 hover:text-slate-900 transition-colors" data-id="element-145">
                Novice
              </a>
            </nav>

            {/* Desktop Auth Buttons */}
            <div className="hidden lg:flex items-center gap-3" data-id="element-146">
              <button className="px-6 py-2.5 rounded-lg border border-gray-300 text-slate-700 hover:border-gray-400 transition-colors" data-id="element-147">
                Registracija
              </button>
              <button className="px-6 py-2.5 rounded-lg bg-[#1EB6E8] text-white hover:bg-[#1aa3d1] transition-colors" data-id="element-148">
                Prijava
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 text-slate-700" aria-label="Toggle menu" data-id="element-149">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-150" /> : <Menu className="w-6 h-6" data-id="element-151" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden border-t border-gray-100 bg-white" data-id="element-152">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-4" data-id="element-153">
            <a href="#" className="text-slate-700 hover:text-slate-900 py-2" data-id="element-154">
              Kupi
            </a>
            <a href="#" className="text-[#1EB6E8] font-medium py-2" data-id="element-155">
              Prodaj
            </a>
            <a href="#kako-deluje" className="text-slate-700 hover:text-slate-900 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-156">
              Kako deluje?
            </a>
            <a href="#faq" className="text-slate-700 hover:text-slate-900 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-157">
              Pogosta vprašanja
            </a>
            <a href="#" className="text-slate-700 hover:text-slate-900 py-2" data-id="element-158">
              Novice
            </a>
            <div className="flex flex-col gap-2 pt-4 border-t border-gray-100" data-id="element-159">
              <button className="px-6 py-2.5 rounded-lg border border-gray-300 text-slate-700" data-id="element-160">
                Registracija
              </button>
              <button className="px-6 py-2.5 rounded-lg bg-[#1EB6E8] text-white" data-id="element-161">
                Prijava
              </button>
            </div>
          </nav>
        </div>}
    </header>;
}